import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { LeadFormProps, LeadFormStepFields } from "@/component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@/component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { FormRadio, ProgressButton } from "@/shared/ui";
import { REQUEST_CONSULTANT_CALL_OPTIONS } from "../constants";
import { isConsultantUsedCalculator } from "../domain";

interface Props extends LeadFormProps {
	consultant?: string;
	source?: string;
}

export interface StepFields extends LeadFormStepFields {
	requestConsultantCall: boolean;
	lastName: string;
	firstName: string;
	email: string;
	phone: string;
	cityName: string;
	cityId?: number;
}

export class LeadForm extends BasicLeadForm<StepFields, Props> {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: <>A részletes eredményedet e-mailben fogjuk elküldeni számodra!</>,
	};

	protected initValues(): StepFields {
		return {
			lastName: undefined,
			firstName: undefined,
			cityName: undefined,
			phone: undefined,
			email: undefined,
			cityId: undefined,
			requestConsultantCall: undefined,
		};
	}

	protected renderContent(_values: StepFields, _form: FormApi<StepFields, Partial<StepFields>>): ReactNode {
		const { consultant, source } = this.props;
		return (
			<>
				{super.renderHeader()}
				<Card.Body className="bg-white">
					{super.renderFields()}
					{!isConsultantUsedCalculator(consultant, source) && (
						<FormRadio
							label=""
							name="requestConsultantCall"
							options={REQUEST_CONSULTANT_CALL_OPTIONS}
							variant="button"
							required
							boldFirstOption
							className="text-dark border rounded pt-2"
						/>
					)}
					{super.renderPrivacyStatement()}
				</Card.Body>
				<Card.Footer className="text-center bg-white">
					<ProgressButton
						type="submit"
						variant="primary"
						className="font-weight-bold"
						block
						disabled={super.isDisabled()}
					>
						Elküldöm
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
